import { compile } from 'path-to-regexp';
import queryString from 'query-string';

export const regOptToPath = ({
  pathname,
  params,
  query,
  baseUrl,
}: {
  pathname: string;
  baseUrl?: string;
  params?: Record<string, any>;
  query?: Record<string, any>;
}) => {
  const qsString = query ? `?${queryString.stringify(query)}` : '';

  const _toPathCompile = compile(pathname, {
    encode: encodeURIComponent,
  });

  let result = '';
  try {
    result = _toPathCompile(params) + qsString;
  } catch (error) {
    result = pathname + qsString;
  }
  if (baseUrl) {
    result = baseUrl + result;
  }
  return result;
};
